import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteWorkHistoryJobModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteWorkHistoryJobModalContainer" */
      './DeleteWorkHistoryJobModalContainer'
    ),
  loading: LoadingModal,
});
